import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
// import { RECENT_COMPARABLE_TRANSACTION } from 'pages/Investor/FinancialModel/fakedata2';

const StyledTableCellStrong = withStyles((theme) => ({
  head: {
    backgroundColor: '#FFF',
    fontWeight: 'bold'
  },
  body: {
    fontSize: 13,
    fontWeight: 'bold',
    borderBottom: 'none !important'
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 350
  },
  paper: {
    marginTop: 15
  }
});

function createData(issuerTarget, date, size) {
  return { issuerTarget, date, size };
}

const rows = [
  createData('Grab', 'Aug-2020', '200M$'),
  createData('Gett', 'Jul-2020', '100M$'),
  createData('Superpedestrian', 'June-2020', '55M$'),
  createData('TIER Mobility', 'June-2020', '122M$'),
  createData('Lime', 'June-2020', '170M$'),
  createData('Bolt', 'May-2020', '109M$'),
  createData('Waymo', 'May-2020', '3,000M$'),
  createData('Getaround', 'April-2020', '63M$'),
  createData('Via', 'March-2020', '200M$')
];

const RecentTransacTable = () => {
  const classes = useStyles();

  return (
    <TableContainer className={classes.paper} component={Paper}>
      <Table aria-label="a dense table" className={classes.table} size="small">
        <TableHead>
          <TableRow>
            <StyledTableCellStrong>ISSUER (TARGET)</StyledTableCellStrong>
            <StyledTableCellStrong align="right">DATE</StyledTableCellStrong>
            <StyledTableCellStrong align="right">SIZE</StyledTableCellStrong>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.issuerTarget}>
              <TableCell component="th" scope="row">
                {row.issuerTarget}
              </TableCell>
              <TableCell align="right">{row.date}</TableCell>
              <TableCell align="right">{row.size}</TableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RecentTransacTable;
